import { render, staticRenderFns } from "./NotasNivel2DadosListaConsolidado.vue?vue&type=template&id=b70bd032"
import script from "./NotasNivel2DadosListaConsolidado.vue?vue&type=script&lang=js"
export * from "./NotasNivel2DadosListaConsolidado.vue?vue&type=script&lang=js"
import style0 from "./NotasNivel2DadosListaConsolidado.vue?vue&type=style&index=0&id=b70bd032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports